import { createContext } from 'react';

const DisplayContext = createContext(null);

export default DisplayContext;
